'use client';

import React, { useEffect } from 'react';

import { Box, BoxContent, Title, TitleLevels, TitleMarkup } from '@bytel/trilogy-react';

export type CategoryBoxProps = {
    title: string;
    isLoading?: boolean;
    formId?: string;
    children: React.ReactNode;
};

export function CategoryBox({ title, isLoading, formId, children }: CategoryBoxProps) {
    useEffect(() => {
        if (window.location.hash === `#${formId}`) {
            document.querySelector(window.location.hash)?.scrollIntoView({ behavior: 'smooth' });
        }
    }, [formId]);

    return (
        <Box shadowless skeleton={isLoading} className='remove-section-padding'>
            <BoxContent>
                <Title markup={TitleMarkup.H2} level={TitleLevels.FOUR}>
                    {title}
                </Title>
                <form id={formId} className='ignore-sticky-scroll'>
                    {children}
                </form>
            </BoxContent>
        </Box>
    );
}
